export default (entity = {}) => {
    return {
        key: entity.key || '',
        platform: entity.platform || 'kiosk',
        note: entity.note || '',
        chainId: entity.chainId || null,
    };
};
